/* Fransk katalog for locale-no.js (del 2 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'fi.recheck': 'J\'ai confirmé',
  'fi.stillUnverified': 'L\'adresse n\'est toujours pas confirmée. Vérifiez votre boîte de réception et vos courriers indésirables.',
  'fi.decline': 'Refuser',
  'fi.declined': 'L\'invitation a été refusée.',
  'set.firm.title': 'Cabinet comptable',
  'set.firm.sub': 'Le cabinet n\'a accès à la comptabilité qu\'une fois que vous avez accepté, et le perd dès que vous mettez fin à la collaboration.',
  'set.firm.none': 'Aucun cabinet comptable n\'a accès à cette entreprise, et aucun ne l\'a demandé.',
  'set.firm.pending': 'En attente de votre réponse',
  'set.firm.active': 'A accès',
  'set.firm.end': 'Mettre fin à la collaboration',
  'set.firm.endConfirm': 'Mettre fin à la collaboration avec {firm} ? Ses collaborateurs perdent immédiatement l\'accès à la comptabilité.',
  'set.firm.ended': 'La collaboration a pris fin et l\'accès a été retiré.',
  'set.firm.onlyManagers': 'Seuls le propriétaire et les administrateurs peuvent répondre à une demande.',
  'rf.create.title': 'Créer un cabinet comptable',
  'rf.create.eyebrow': 'Cabinet comptable',
  'rf.create.readyBody': 'Le cabinet est créé et vous en êtes propriétaire. Prochaine étape : invitez vos collaborateurs et rattachez vos clients.',
  'rf.create.openSurface': 'Ouvrir l\'espace cabinet',
  'rf.create.body': 'Le cabinet est recherché dans l\'Enhetsregisteret. Vous en devenez propriétaire et pouvez ensuite inviter des collaborateurs.',
  'rf.create.orgNumber': 'Numéro d\'organisation',
  'rf.create.hintDigits': 'Neuf chiffres. Le cabinet doit être immatriculé à l\'Enhetsregisteret.',
  'rf.create.hintReady': 'Le numéro est recherché dans l\'Enhetsregisteret lors de la création.',
  'rf.create.hintDemo': 'Le compte de démonstration peut utiliser un numéro fictif. Donnez un nom au cabinet ci-dessous.',
  'rf.create.firmName': 'Nom du cabinet',
  'rf.create.nameRequired': 'L\'entreprise est introuvable dans l\'Enhetsregisteret. Saisissez le nom du cabinet pour continuer.',
  'rf.create.unverifiedNote': 'Le cabinet est créé sans consultation du registre et marqué comme non vérifié. Il doit être vérifié avant la mise en service de vrais cabinets.',
  'rf.create.demoNote': 'Le compte de démonstration définit lui-même le nom. Les comptes ordinaires reçoivent le nom de l\'Enhetsregisteret.',
  'rf.create.submit': 'Créer le cabinet',
  'rf.create.working': 'Création …',
  'rf.create.done': 'Le cabinet comptable a été créé',
  'rf.create.note': 'La consultation confirme que l\'entreprise existe. Elle ne vérifie pas si vous pouvez agir en son nom.',
  'rf.member.title': 'Fonction',
  'rf.member.email': 'E-mail',
  'rf.member.person': 'Personne',
  'rf.member.rights': 'Droits',
  'rf.member.inviteTitle': 'Inviter un collaborateur',
  'rf.member.invite': 'Envoyer l\'invitation',
  'rf.member.inviting': 'Envoi …',
  'rf.member.invited': 'Invitation envoyée',
  'rf.member.inviteMailFailed': 'L\'invitation a été créée, mais l\'e-mail n\'a pas pu être envoyé.',
  'rf.member.listTitle': 'Collaborateurs',
  'rf.member.none': 'Aucun collaborateur pour l\'instant.',
  'rf.member.updated': 'La fonction a été modifiée',
  'rf.member.remove': 'Retirer l\'accès',
  'rf.member.removed': 'L\'accès a été retiré',
  'rf.member.removedWithClients': 'L\'accès a été retiré, y compris chez {count} clients.',
  'rf.member.removeConfirm': 'Retirer l\'accès de {name} ? Tous les accès clients que le cabinet a accordés à cette personne sont retirés en même temps.',
  'rf.member.removeNote': 'Lorsque vous retirez un collaborateur, tous les accès clients que le cabinet lui a accordés sont également retirés — chez tous les clients, en une seule opération.',
  'rf.member.ownerRights': 'Propriétaire du cabinet',
  'rf.member.canControl': 'Peut contrôler',
  'rf.nav.backToApp': 'Vers ma comptabilité',
  'rf.nav.back': 'Retour',
  'app.nobusiness.openFirm': 'Ouvrir le cabinet comptable',
  'rf.tab.close': 'Fermer l\'onglet',
  'rf.tab.assignFirst': 'Personne n\'est encore affecté à la mission pour ce client. L\'accès à la comptabilité suit l\'affectation — affectez quelqu\'un à la mission sous Clients.',
  'rf.tab.assignNeeded': 'Vous n\'êtes pas affecté à la mission de ce client. Demandez à un administrateur du cabinet de vous y affecter.',
  'rf.soon.clients': 'L\'aperçu des clients est en cours de connexion au statut client que le backend calcule pour chaque client.',
  'rf.soon.reconciliation': 'L\'espace de rapprochement est en cours de développement. Le modèle d\'accès et le statut client sur lesquels il repose sont en place.',
  'rf.soon.control': 'L\'espace de contrôle suivra le rapprochement. La règle des quatre yeux sera appliquée dans le backend à son lancement.',
  'rf.noFirm.title': 'Vous n\'êtes membre d\'aucun cabinet comptable',
  'rf.noFirm.body': 'Vous n\'êtes encore membre d\'aucun cabinet. Créez le vôtre ci-dessous, ou demandez à un administrateur du cabinet de vous inviter — l\'invitation arrive par e-mail.',
  'tc.title': 'Chat d\'équipe',
  'tc.rooms': 'Salons',
  'tc.dms': 'Messages directs',
  'tc.newRoom': 'Nouveau salon',
  'tc.roomName': 'Nom du salon',
  'tc.roomNamePlaceholder': 'P. ex. Équipe contrôle',
  'tc.createRoom': 'Créer le salon',
  'tc.noColleagues': 'Personne d\'autre dans le cabinet pour l\'instant',
  'tc.commonRoom': 'Salon commun',
  'tc.room': 'Salon',
  'tc.commonSubtitle': 'Salon partagé pour toute l\'équipe',
  'tc.roomSubtitle': 'Salon du cabinet',
  'tc.dm': 'Message direct',
  'tc.dmSubtitle': 'Message direct',
  'tc.empty': 'Aucun message ici pour l\'instant — écrivez le premier.',
  'tc.placeholder': 'Écrire un message…',
  'tc.send': 'Envoyer',
  'tc.unknown': 'Inconnu',
  'shell.client.clients': 'Vos clients',
  'shell.client.signOutSub': 'Mettre fin à la session sur cet appareil',
  'shell.client.signOutFailed': 'Impossible de se déconnecter. Réessayez.',
  'shell.client.none': 'Aucune entreprise',
  'shell.client.noBusinesses': 'Aucune entreprise',
  'shell.client.connecting': 'Connexion au backend Plumme',
  'shell.client.personalEconomy': 'Finances personnelles',
  'shell.client.accountingClient': 'Client comptable',
  'shell.client.org': 'N° org. {org}',
  'shell.suggest.invoices': 'Factures',
  'shell.suggest.customers': 'Clients',
  'shell.suggest.vouchers': 'Justificatifs',
  'trial.title': 'Période d\'essai active',
  'trial.active': 'La période d\'essai est active.',
  'trial.dayLeft': 'Il vous reste {days} jour.',
  'trial.daysLeft': 'Il vous reste {days} jours.',
  'trial.body': 'Tout fonctionne - profitez-en pour découvrir Plumme.',
  'trial.upgrade': 'Passer à l\'offre supérieure',
  'home.greeting': 'Bon retour 👋',
  'home.registerSale': 'Enregistrer une vente',
  'home.registerSaleHelp': 'Enregistrez une nouvelle vente ou créez une facture pour un client. La vente est comptabilisée automatiquement sur le bon compte.',
  'home.registerPurchase': 'Enregistrer un achat',
  'home.registerPurchaseHelp': 'Enregistrez un achat ou importez un justificatif. SuperPlumma vous suggère le compte et le traitement de TVA.',
  'home.aiHelp': 'Vous voyez ici tout ce que SuperPlumma et ses agents ont fait automatiquement – comptabilité, TVA, paie et plus encore. Vous approuvez d\'une seule touche.',
  'home.autopilot.active': 'Actif',
  'home.autopilot.followUp': 'À suivre',
  'home.autopilot.disabled': 'Désactivé',
  'home.view.period': 'Période',
  'home.view.analysis': 'Analyse',
  'home.view.cashflow': 'Résultat net',
  'home.viewLabel.period': 'Produits et charges par mois',
  'home.viewLabel.analysis': 'Répartition produits vs charges',
  'home.viewLabel.cashflow': 'Résultat net par mois',
  'home.ana.ring': 'Répartition',
  'home.ana.gauge1': 'Indicateurs clés',
  'home.ana.gauge2': 'Indicateurs financiers',
  'home.sub.yoyArrow': 'La flèche indique la variation par rapport à l\'an dernier.',
  'home.sub.exVat': 'Tous les totaux sont affichés HT.',
  'home.legend.in': 'Entrées',
  'home.legend.out': 'Sorties',
  'home.legend.income': 'Produits',
  'home.legend.cost': 'Charges',
  'home.legend.result': 'Résultat',
  'home.legend.cashflow': 'Résultat',
  'home.selectedMonths': 'Mois sélectionnés :',
  'home.reset': 'Réinitialiser',
  'home.sumOfMonth': 'Total sur {n} mois',
  'home.sumOfMonths': 'Total sur {n} mois',
  'home.noPrevPeriod': 'Aucune période précédente',
  'home.fromPrevMonth': 'par rapport au mois précédent',
  'home.fromLastYear': 'par rapport à l\'an dernier',
  'home.showDistribution': 'Afficher la répartition',
  'home.noData': 'Aucune donnée',
  'home.donut.registeredIncome': 'Produits enregistrés',
  'home.donut.registeredCosts': 'Charges enregistrées',
  'home.donut.income': 'Produits',
  'home.donut.costs': 'Charges',
  'home.donut.result': 'Résultat',
  'home.donut.breakdown': '{title} — répartition',
  'home.donut.back': 'Retour',
  'home.donut.hint': 'Appuyez sur une partie de l’anneau ou sur une carte KPI ci-dessous pour voir la répartition',
  'home.health.good': 'Bonne',
  'home.health.balanced': 'Équilibrée',
  'home.health.weak': 'Faible',
  'home.gauge.explain': 'Expliquer cet indicateur',
  'home.gauge.currentValue': 'Valeur actuelle',
  'home.gauge.assessment': 'Évaluation',
  'home.gauge.goodLevel': 'Bon niveau : {good}',
  'home.gauge.income': 'Produits',
  'home.gauge.income.info': 'Les produits correspondent au total de tout ce que l’entreprise a vendu sur la période, hors TVA. Des produits en hausse dans le temps donnent plus de marge de manœuvre.',
  'home.gauge.income.good': 'En hausse dans le temps',
  'home.gauge.costs': 'Charges',
  'home.gauge.costs.info': 'Les charges sont les dépenses nécessaires au fonctionnement de l’entreprise, hors TVA. Des charges plus faibles par rapport aux produits donnent un meilleur résultat.',
  'home.gauge.costs.good': 'Inférieures aux produits',
  'home.gauge.result': 'Résultat',
  'home.gauge.result.info': 'Le résultat est ce qui reste une fois les charges déduites des produits. Un résultat positif signifie un bénéfice sur la période.',
  'home.gauge.result.good': 'Positif et stable',
  'home.gauge.liquidity': 'Liquidité',
  'home.gauge.liquidity.info': 'La liquidité indique la capacité à payer les factures et les dettes à court terme à leur échéance. Une valeur plus élevée offre une meilleure réserve.',
  'home.gauge.liquidity.good': 'Au-dessus de 1,0x, idéalement au-dessus de 2,0x',
  'home.gauge.profitability': 'Rentabilité',
  'home.gauge.profitability.info': 'La rentabilité indique la part des produits qui reste en résultat. Plus le pourcentage est élevé, plus l’entreprise gagne par couronne vendue.',
  'home.gauge.profitability.good': 'Positive et en hausse',
  'home.gauge.solidity': 'Solidité',
  'home.gauge.solidity.info': 'La solidité indique la part de l’entreprise financée par des capitaux propres. Une solidité plus élevée rend l’entreprise plus robuste.',
  'home.gauge.solidity.good': 'Part de capitaux propres en hausse dans le temps',
  'home.assistant.sub': 'Assistant comptable',
  'home.assistant.intro': 'Bonjour ! Je peux effectuer des actions simples pour vous, créer des factures, enregistrer des achats, expliquer les taxes et comptabiliser des justificatifs depuis la boîte de réception. N’hésitez pas à demander. Pour des conseils financiers, le conseiller est disponible sur la page AI Conseiller.',
  'home.assistant.thinking': 'SuperPlumma réfléchit...',
  'home.assistant.placeholder': 'Demandez à SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma n’a reçu aucune réponse du backend.',
  'home.assistant.errorReply': 'Impossible d’obtenir une réponse de l’assistant pour le moment.',
  'home.assistant.errorToast': 'Impossible d’obtenir la réponse de l’assistant.',
  'home.assistant.cancel': 'Annuler',
  'home.assistant.opened': 'J’ai ouvert la bonne page avec la proposition prête à être vérifiée.',
  'home.assistant.openedToast': 'Parcours approprié ouvert',
  'home.assistant.noAdapter': 'Cette action n’a pas encore d’adaptateur Plumme.',
  'home.assistant.paymentNotConnected': 'L’enregistrement des paiements n’est pas connecté au backend.',
  'home.assistant.paymentRegistered': 'Un paiement de {sum} a été enregistré sur la facture{number}.',
  'home.assistant.paymentToast': 'Paiement enregistré',
  'home.assistant.paymentFailed': 'Impossible d’enregistrer le paiement.',
  'home.assistant.cancelled': 'D’accord, je n’ai rien modifié.',
  'home.assistant.sugg1': 'Combien dois-je en taxes ?',
  'home.assistant.sugg2': 'Créer une facture pour un client',
  'home.assistant.sugg3': 'Qu’est-ce que la TVA ?',
  'home.action.register_payment': 'Approuver le paiement',
  'home.action.create_invoice': 'Ouvrir le brouillon de facture',
  'home.action.create_other_sale': 'Ouvrir Autre vente',
  'home.action.create_expense': 'Ouvrir un nouvel achat',
  'home.action.register_purchase': 'Ouvrir un nouvel achat',
  'home.action.create_customer': 'Enregistrer le client',
  'home.action.create_supplier': 'Enregistrer le fournisseur',
  'home.action.create_product': 'Enregistrer le produit',
  'home.action.suggest_accounting_entry': 'Ouvrir une écriture libre',
  'home.action.create_mileage_entry': 'Ouvrir le journal de bord kilométrique',
  'home.action.send_sales_document': 'Ouvrir la liste des factures',
  'home.action.book_bank_lines': 'Ouvrir la banque',
  'home.action.link_bank_receipts': 'Ouvrir la banque',
  'home.action.annul_bank_posting': 'Ouvrir la banque',
  'home.action.reporting_preparation': 'Ouvrir les déclarations',
  'home.action.default': 'Ouvrir le parcours',
  'home.followup.title': 'Suivi',
  'home.followup.allClear': 'Tout est sous contrôle',
  'home.followup.allClearSub': 'Rien à suivre pour le moment. Plumme vous préviendra lorsque quelque chose nécessitera votre attention.',
  'home.followup.next': 'Continuer',
  'home.followup.showMore': 'Afficher plus',
  'home.followup.modalTitle': 'Tâches à traiter',
  'home.followup.sales': 'Ventes',
  'home.followup.purchases': 'Achats',
  'home.followup.toInvoiceList': 'Aller à la liste des factures',
  'home.followup.toVoucherList': 'Aller à la liste des justificatifs',
  'home.followup.draftInvoices': 'Vous avez {n} brouillons de facture non finalisés.',
  'home.followup.unsentInvoices': 'Vous avez {n} factures prêtes mais non envoyées.',
  'home.followup.overdueInvoices': 'Vous avez {n} factures échues non réglées.',
  'home.followup.openPurchases': 'Vous avez {n} factures fournisseurs non réglées.',
  'home.followup.missingAttachments': 'Vous avez {n} achats sans justificatif.',
  'home.followup.bank': 'Rapprochement bancaire',
  'home.followup.toBank': 'Aller au rapprochement bancaire',
  'home.followup.missingBankStatements': 'Il manque le relevé bancaire du compte courant pour {months}',
  'home.overview.sales': 'Ventes',
  'home.overview.purchases': 'Achats',
  'home.overview.outstandingSales': 'Ventes en attente de paiement',
  'home.overview.outstandingPurchases': 'Achats en attente de paiement',
  'home.overview.salesHelp': 'Les ventes en attente de paiement sont les factures que vos clients n’ont pas encore payées. Le vert est dans les délais, le jaune est échu — relancez les factures échues.',
  'home.overview.purchasesHelp': 'Les achats en attente de paiement sont les factures fournisseurs que vous n’avez pas encore payées. Le vert est dans les délais, le jaune est échu et doit être payé rapidement.',
  'home.overview.importedSubledger': 'Dont auxiliaire importé : {amount}',
  'home.overview.inclVat': 'Les montants sont TTC.',
  'home.overview.helpTitle': '{what} en attente de paiement',
  'home.overview.withinDue': 'Dans les délais',
  'home.overview.overdue': 'Échu',
  'home.overview.statusTitle': '{within} % dans les délais · {over} % échu',
  'home.deadlines.title': 'Échéances à venir',
  'home.deadlines.help': 'Échéances de dépôt à venir - MVA-melding, skattemelding, comptes annuels et aksjonærregisteroppgave, avec le statut de chacune.',
  'home.deadlines.none': 'Aucune échéance trouvée dans les données du backend.',
  'home.deadlines.seeStatus': 'Voir le statut',
  'home.deadlines.helpTax': 'La skattemelding rassemble la comptabilité et le calcul de l’impôt de l’année. Plumme vous aide à vérifier les chiffres avant le dépôt.',
  'home.deadlines.helpAnnualAccounts': 'Les comptes annuels rassemblent le compte de résultat, le bilan et l’annexe de l’exercice et sont déposés au Regnskapsregisteret une fois prêts.',
  'home.deadlines.helpAnnualClosing': 'La clôture annuelle clôt l’exercice avec des contrôles, l’affectation du résultat et les écritures de clôture nécessaires.',
  'home.deadlines.helpShareholderRegister': 'L’aksjonærregisteroppgave (RF-1086) est déposée par les sociétés par actions au plus tard le 31 janvier de l’année suivant l’année fiscale. Plumme ne permet pas de la déposer — ceci est un rappel.',
  'home.deadlines.helpVat': 'La MVA-melding déclare la TVA collectée et la TVA déductible pour la période.',
  'home.deadlines.helpFallback': 'Échéance pour {name}. Plumme vous prévient et vous guide depuis la vue du statut.',
  'home.deadlines.fallbackName': 'dépôt',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgave',
  'home.fees.title': 'Taxes publiques',
  'home.fees.help': 'Aperçu de ce que vous devez actuellement à l’administration - taxe sur la valeur ajoutée (TVA), prélèvement à la source et cotisations patronales. Calculé en continu à partir de la comptabilité.',
  'home.fees.none': 'Aucune taxe publique en attente trouvée.',
  'home.balances.title': 'Soldes',
  'home.balances.help': 'Soldes comptabilisés des comptes bancaires, de caisse et autres. Les chiffres proviennent de la balance générale : ils montrent ce que dit la comptabilité - pas ce que la banque a déjà mis à jour. Avec la roue dentée, vous choisissez les comptes affichés et pouvez en rechercher d’autres dans le plan comptable. Le compte courant et la caisse peuvent être masqués, mais pas supprimés.',
  'home.balances.choose': 'Choisir les comptes',
  'home.balances.total': 'Total',
  'home.balances.accountFallback': 'Compte {code}',
  'home.balances.noneSelected': 'Aucun compte sélectionné.',
  'home.balances.searchPlaceholder': 'Rechercher dans le plan comptable …',
  'home.balances.noHits': 'Aucun résultat',
  'home.balances.remove': 'Retirer de la carte',
  'home.balances.saveFailed': 'Impossible d\'enregistrer la sélection de comptes.',
  'set.account': 'Compte',
  'set.amount': 'Montant',
  'set.page': 'Page',
  'set.debit': 'Débit',
  'set.credit': 'Crédit',
  'set.remove': 'Retirer',
  'set.ib.title': 'Bilan d\'ouverture',
  'set.ib.startWizard': 'Lancer l\'assistant pour créer le bilan d\'ouverture',
  'set.ib.confirmDate': 'Confirmer la date de démarrage',
  'set.ib.setUp': 'Configurer le bilan d\'ouverture',
  'set.ib.confirmDateInPlumme': 'Confirmer la date de démarrage dans Plumme',
  'set.ib.startDate': 'Date de démarrage',
  'set.back': 'Retour',
  'set.ib.dateOk': 'La date est correcte, continuer',
  'set.ib.draftEmpty': 'Le brouillon est vide.',
  'set.text': 'Libellé',
  'set.toDebit': 'Vers (débit)',
  'set.fromCredit': 'Depuis (crédit)',
  'set.editLine': 'Modifier la ligne',
  'set.removeLine': 'Retirer la ligne',
  'set.quickPick': 'Choix rapides',
  'set.addNewLine': 'Ajouter une ligne',
  'set.saved': 'Enregistré',
  'set.startOver': 'Recommencer',
  'set.ib.finish': 'Finaliser le bilan d\'ouverture',
  'set.ib.summary': 'Récapitulatif - montants entrant et sortant des comptes',
  'set.ib.openNote': 'L\'écriture est ouverte et peut être modifiée depuis cette vue.',
  'set.ib.intoAccount': 'Vers le compte',
  'set.ib.outOfAccount': 'Depuis le compte',
  'set.sum': 'Total',
  'set.ib.openEntry': 'Écriture ouverte',
  'set.accountNo': 'N° de compte',
  'set.name': 'Nom',
  'set.vatCode': 'Code TVA',
  'set.description': 'Description',
  'set.relevantLinks': 'Liens utiles',
  'set.deleteCancel': 'Supprimer / annuler',
  'set.ib.edit': 'Modifier le bilan d\'ouverture',
  'set.ib.openingForAccount': 'Solde d\'ouverture du compte',
  'set.cancel': 'Annuler',
  'set.save': 'Enregistrer',
  'set.ib.postDescription': 'Description de l\'écriture',
  'set.pickAccount': 'Choisir un compte ...',
  'set.accountDebit': 'Compte (débit)',
  'set.ib.cannotBeEmpty': 'Impossible de créer un bilan d\'ouverture vide',
  'set.continueTitle': 'Continuer ?',
  'set.ib.post': 'Comptabiliser le bilan d\'ouverture',
  'set.ib.draftTitle': 'Brouillon du bilan d\'ouverture',
  'set.ib.draftHelp': 'Saisissez les chiffres de bilan de votre ancien système afin que la balance générale démarre correctement dans Plumme.',
  'set.noteOptional': 'Note (facultatif)',
  'set.notePh': 'Par exemple ce qui a été importé et à partir de quelle date',
  'set.ib.lines': 'Lignes de bilan',
  'set.ib.linesHelp': 'Les chiffres du bilan à la date de transition, répartis par compte : actifs, capitaux propres et dettes de l\'ancien système. Saisissez une ligne par compte afin que le bilan démarre avec les bons chiffres dans Plumme.',
  'set.ib.addLine': 'Ajouter une ligne de bilan',
  'set.startup.title': 'Chiffres de démarrage',
  'set.startup.introText': 'Utilisez cette option si vous passez à Plumme en cours d\'année {year}. Vous saisissez les chiffres de TVA et de résultat de votre ancien système, afin que les rapports et la skattemelding se poursuivent correctement à partir de la date de transition.',
  'set.startup.startWizard': 'Lancer l\'assistant pour saisir les chiffres de démarrage',
  'set.startup.stepDate': 'Date de transition et TVA',
  'set.startup.stepLines': 'Ventes et charges',
  'set.startup.confirmTitle': 'Confirmer la date de transition et la TVA à ce jour',
  'set.startup.linesTitle': 'Répartir les chiffres antérieurs au {date}',
  'set.startup.save': 'Enregistrer les chiffres de démarrage',
  'set.startup.receiptTitle': 'Chiffres de démarrage au {date}',
  'set.startup.receiptSub': 'Enregistrés pour la transition vers Plumme',
  'set.startup.receiptLines': 'Lignes enregistrées : {lines} - ventes {sales} et charges {costs}.',
  'set.startup.edit': 'Modifier les chiffres de démarrage',
  'set.transitionDate': 'Date de transition',
  'set.transitionDateHelp': 'La date à laquelle vous êtes passé à Plumme. Les chiffres de démarrage couvrent la période du début de l\'année jusqu\'à cette date, tenue dans l\'ancien système.',
  'set.outputVatBefore': 'TVA collectée avant le démarrage',
  'set.outputVatBeforeHelp': 'La TVA déjà collectée sur les ventes depuis le début de l\'année, avant la transition. Elle s\'ajoute aux chiffres de TVA de l\'année afin que la MVA-melding soit correcte.',
  'set.inputVatBefore': 'TVA déductible avant le démarrage',
  'set.inputVatBeforeHelp': 'La TVA déjà payée sur les achats depuis le début de l\'année (et déductible), avant la transition.',
  'set.salesByAccount': 'Ventes par compte',
  'set.salesByAccountHelp': 'Le chiffre d\'affaires depuis le début de l\'année, réparti par compte de produits. Saisissez une ligne par compte de ventes afin que le compte de résultat démarre avec les bons chiffres.',
  'set.salesByAccountBefore': 'Ventes par compte avant le démarrage',
  'set.addSalesLine': 'Ajouter une ligne de vente',
  'set.noSalesLines': 'Aucune ligne de vente pour l\'instant.',
  'set.costsByAccount': 'Charges par compte',
  'set.costsByAccountHelp': 'Les charges depuis le début de l\'année, réparties par compte de charges. Saisissez une ligne par compte de charges afin que le résultat soit correct à partir de la date de transition.',
  'set.costsByAccountBefore': 'Charges par compte avant le démarrage',
  'set.addCostLine': 'Ajouter une ligne de charge',
  'set.noCostLines': 'Aucune ligne de charge pour l\'instant.',
  'set.import.title': 'Importer une comptabilité complète',
  'set.import.pickPackage': 'Choisir les fichiers d\'export',
  'set.import.shouldContain': 'Le paquet doit contenir',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Fichier clients et fournisseurs, de préférence en Excel ou CSV',
  'set.import.chart': 'Plan comptable',
  'set.import.vouchers': 'Justificatifs, reçus et factures en PDF ou images',
  'set.import.bankRecs': 'Rapprochements bancaires et copies de factures',
  'set.import.firstStep': 'Première étape dans Plumme',
  'set.import.readsStructure': 'Lit la structure des fichiers',
  'set.import.findsFiles': 'Trouve les fichiers SAF-T, Excel et justificatifs',
  'set.import.buildsAnalysis': 'Établit une analyse d\'import',
  'set.import.letsApprove': 'Vous permet d\'approuver un import sûr du plan comptable, des clients, des fournisseurs et du bilan d\'ouverture',
  'set.import.notAutomatic': 'Pas encore automatique',
  'set.import.noPromise': 'Plumme ne garantit pas que tout sera strictement identique à votre ancien système',
  'set.import.noHistoric': 'Les écritures historiques ne sont pas comptabilisées sans approbation',
  'set.import.nothingToAltinn': 'Rien n\'est envoyé à Altinn',
  'set.import.noOverwrite': 'Les justificatifs existants ne sont ni supprimés ni écrasés sans confirmation',
  'set.close': 'Fermer',
  'set.import.approveBase': 'Approuver l\'import des données de base',
  'set.import.working': 'Traitement...',
  'set.import.uploading': 'Importation vers Firebase Storage',
  'set.import.serverReading': 'Le serveur lit maintenant les fichiers d\'import',
  'set.import.importingBase': 'Import des données de base',
  'set.import.savedInAccounts': 'L\'import est enregistré dans la comptabilité',
  'set.import.checkBefore': 'Vérifiez le plan comptable, les clients, les fournisseurs et le bilan d\'ouverture avant tout reporting.',
  'set.import.dataOnlyTitle': 'Importer uniquement les données comptables (recommandé)',
  'set.import.dataOnlyHelp': 'Plumme crée dans votre navigateur une copie filtrée contenant SAF-T, CSV et Excel. Les PDF, images et autres documents ne sont pas importés.',
  'set.import.dataOnlyKeepOriginal': 'Conservez le fichier ZIP d\'origine de Fiken.',
  'set.import.dataOnlyFiltering': 'Suppression des documents avant l\'import',
  'set.import.dataOnlyFilteringHelp': 'Le fichier d\'origine n\'est pas modifié. Seul le nouveau paquet de données filtré est envoyé à Plumme.',
  'set.import.dataOnlyFiltered': 'Fichiers de documents et justificatifs exclus de l\'import : {count}.',
  'set.import.dataOnlyLibraryFailed': 'Impossible de charger le filtre ZIP. Réessayez ou extrayez manuellement les fichiers SAF-T, CSV et Excel.',
  'set.import.dataOnlyNoFiles': 'Aucun fichier SAF-T, CSV ou Excel trouvé dans le paquet ZIP.',
  'set.import.packages.title': 'Paquets d\'import enregistrés',
  'set.import.packages.help': 'Vous voyez ici tous les fichiers ZIP et le paquet qui sert de source active pour l\'archive d\'import.',
  'set.import.packages.loading': 'Chargement des paquets...',
  'set.import.packages.empty': 'Aucun fichier ZIP enregistré.',
  'set.import.packages.statusImported': 'Import actif',
  'set.import.packages.statusDuplicate': 'Doublon identique',
  'set.import.packages.statusPrevious': 'Import précédent',
  'set.import.packages.statusAnalyzed': 'Lu',
  'set.import.packages.statusFailed': 'Échec de la lecture',
  'set.import.packages.statusAnalyzing': 'Lecture en cours',
});
